module.exports = __webpack_public_path__ + "static/media/Mithun-Suvarna.205a7889.svg";